import React from 'react';
import { PluginSlot } from '@openedx/frontend-plugin-framework';

const NotificationsSlot = () => (
  <PluginSlot id="notifications_tray" />
);

export default NotificationsSlot;
